import {List} from 'immutable';

import {addToast} from '@albert-io/atomic';
import {
  getIndiePracticeSubjectsQuery,
  getClassroomIndiePracticeSubjectsQuery
} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import type {SubjectModelV2} from '@albert-io/models';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function useIndependentPracticeSubjects(classroomId?: string) {
  const areIndependentPracticeSubjectsLoading = useStudentDashboard(
    (state) => state.areIndependentPracticeSubjectsLoading
  );
  const independentPracticeSubjects = useStudentDashboard(
    (state) => state.independentPracticeSubjects
  );
  const setAreIndependentPracticeSubjectsLoading = useStudentDashboard(
    (state) => state.setAreIndependentPracticeSubjectsLoading
  );
  const setIndependentPracticeSubjects = useStudentDashboard(
    (state) => state.setIndependentPracticeSubjects
  );

  function fetchIndependentPracticeSubjects() {
    setAreIndependentPracticeSubjectsLoading(true);

    const query = classroomId
      ? getClassroomIndiePracticeSubjectsQuery(classroomId)
      : getIndiePracticeSubjectsQuery();

    query.invalidateInterest();

    query
      .getResourcePromise()
      .then((result: List<SubjectModelV2>) => {
        const filteredSubjects = result.toArray().filter((subject) => !subject.isAdaptive());
        setIndependentPracticeSubjects(filteredSubjects);
      })
      .catch(() => {
        addToast({
          color: 'negative',
          message: 'Failed to load independent practice subjects.'
        });

        setIndependentPracticeSubjects([]);
      })
      .finally(() => {
        setAreIndependentPracticeSubjectsLoading(false);
      });
  }

  return {
    areIndependentPracticeSubjectsLoading,
    fetchIndependentPracticeSubjects,
    independentPracticeSubjects
  };
}
